<template>
  <!--新增弹出框-->
  <el-dialog
    :visible.sync="templateBookingVisible"
    title="选择模板"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthTemplateBooking"
  >
    <div class="container">
      <!-- 模板名称 start -->
      <el-row :gutter="10" style="margin-bottom: 50px">
        <el-col :span="4" style="margin-top: 2px">
          <span style="margin-top: 5px">模板名称</span>
        </el-col>

        <el-form label-position="top" size="mini" :model="ebOrderTemplate"
                 :validateOnRuleChange="false" ref="ruleFormRef" :rules="rulesForm">
          <el-col :span="20">
            <el-form-item prop="templateName">
              <el-associate style="width: 100%;"
                            :columns="associate_columns_ebOrderTemplate"
                            :query-method="associate_queryMethod_ebOrderTemplate"
                            class="input_length"
                            clearable
                            :query-length="1"
                            :default-first-option="true"
                            label-prop="templateName"
                            value-prop="templateName"
                            v-model="ebOrderTemplate.templateName"
                            :title="ebOrderTemplate.templateName"
                            placeholder=""
                            size="mini"
                            @change="onChangeEbOrderTemplate"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <!-- 模板名称 end -->
      <!-- 按钮 start -->
      <el-row
        type="flex"
        justify="center"
        align="middle"
        :gutter="10"
        class="el-row-margin"
      >
        <el-button type="primary" size="small" plain @click="sure">确认</el-button>
        <el-button type="info" size="small" plain @click="close">取消</el-button>
      </el-row>
      <!-- 按钮 end -->
    </div>
  </el-dialog>
</template>

<script>

  import ebOrderTemplate from "@/api/ebOrderTemplate";

  export default {
    name: 'templateBookingUpBox',
    props: {
      templateBookingVisibleFlagInit: Boolean,
    },
    data() {
      return {
        //非空校验
        rulesForm: {
          templateName: [{
            required: true,
            message: "请选择一个模板",
            trigger: ['blur', 'change']
          }]
        },
        templateBookingVisible: false,
        // 模板名称联想控件
        associate_columns_ebOrderTemplate: [
          {
            title: "模板名称",
            field: 'templateName'
          }
        ],
        ebOrderTemplate: {
          templateName: ''
        }
      }
    },
    // 监听
    watch: {
      templateBookingVisibleFlagInit() {
        let self = this
        self.templateBookingVisible = true
      }
    },
    async created() {

    },
    mounted() {

    },
    methods: {
      // 模板名称联想控件数据源
      associate_queryMethod_ebOrderTemplate({keyword, pageSize, currentPage}) {
        let params = {}
        params.templateName = keyword
        params.page = currentPage
        params.limit = pageSize
        return new Promise(resolve => {
          ebOrderTemplate.queryEbOrderTemplate(params).then(res => {
            console.log(res)
            resolve({
              records: res.data.data,
              total: res.data.totalRecord
            })
          })
        }).catch(err => {
          console.log(err)
        })
      },
      //模板名称修改事件
      onChangeEbOrderTemplate(value, selectedRows) {
        this.ebOrderTemplate = selectedRows
      },
      //确认
      sure() {
        let self = this
        //非空校验
        self.$refs.ruleFormRef.validate(async valid => {
          if (valid) {
            self.templateBookingVisible = false
            this.$router.push({
              name: "bookingAdd",
              params: {
                allData: this.ebOrderTemplate.jsonInfo,
              }
            })
          }
        })
      },
      //关闭
      close() {
        let self = this
        self.templateBookingVisible = false
      }
    }
  }
</script>

<style>
  .customWidthTemplateBooking {
    width: 35%;
    height: 230px;
  }

  .el-dialog__body {
    padding: 0px;
  }

</style>
